import { render, staticRenderFns } from "./landList.vue?vue&type=template&id=310fbaa9&"
import script from "./landList.vue?vue&type=script&lang=js&"
export * from "./landList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports